import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    skeleton: {
        animation: '$pulse 1.5s infinite ease-in-out',
        backgroundColor: '#e3e3e3',
        borderRadius: '4px',
        display: 'inline-block',
    },
    skeletonText: {
        borderRadius: '4px',
        height: '12px',
        marginBottom: '8px',
        width: '100%',
    },
    skeletonBtn: {
        borderRadius: '6px',
        height: '38px',
        width: '100px',
    },
    skeletonIcon: {
        borderRadius: '50%',
        height: '24px',
        width: '24px',
    },
    skeletonBadge: {
        borderRadius: '12px',
        height: '24px',
        width: '30px',
    },
    '@keyframes pulse': {
        '0%': { opacity: 1 },
        '50%': { opacity: 0.5 },
        '100%': { opacity: 1 },
    },
});

export const SkeletonLoader: FC<{
    className?: string;
    height?: string | number;
    type: 'text' | 'btn' | 'icon' | 'badge';
    width?: string | number;
}> = ({ type, className, width, height }) => {
    const classes = useStyles();

    const getSkeletonClass = () => {
        switch (type) {
            case 'badge':
                return classes.skeletonBadge;
            case 'btn':
                return classes.skeletonBtn;
            case 'icon':
                return classes.skeletonIcon;
            case 'text':
                return classes.skeletonText;
            default:
                return classes.skeletonText;
        }
    };

    return (
        <div
            aria-hidden="true"
            className={`${classes.skeleton} ${getSkeletonClass()} ${className || ''}`}
            data-testid={`skeleton-${type}`}
            style={{ width, height }}
        />
    );
};
